import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Landing from '../pages/landing/index.vue'/* KissMora landing */
import AuthLogin from '../pages/auth/Login.vue'/* KissMora login */
import AuthRegister from '../pages/auth/Register.vue'/* KissMora register */
import VerifyEmail from '../pages/auth/VerifyEmail.vue'/* KissMora email verification landing */
import Discover from '../pages/discover/index.vue'/* KissMora Tinder-style swipe deck */
import Chats from '../pages/chats/index.vue'/* KissMora messages */
import ChatThread from '../pages/chats/thread.vue'/* Individual conversation */
import Support from '../pages/support/index.vue'/* KissMora live support chat */
import Deposit from '../pages/deposit/index.vue'/* KissMora crypto deposit */
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* Choose — address tabs + profile grid (original logic, new UI) */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Kyc       from '../pages/mine/Kyc.vue'/* KissMora: identity verification */
import Gifts     from '../pages/mine/Gifts.vue'/* KissMora: gifts hub */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

Vue.use(VueRouter)
const SITE_TITLE = 'KissMora'
const t = (page) => page ? page + ' - ' + SITE_TITLE : SITE_TITLE
const routes = [
    {path:'/',name:'landing',component:Landing,meta:{title:t('Find Your Kiss')}},
    {path:'/Discover',name:'discover',component:Discover,meta:{title:t('Discover')}},
    {path:'/Chats',name:'chats',component:Chats,meta:{title:t('Messages')}},
    {path:'/Chat',name:'chat-thread',component:ChatThread,meta:{title:t('Chat')}},
    {path:'/Support',name:'support',component:Support,meta:{title:t('Support')}},
    {path:'/Deposit',name:'Deposit',component:Deposit,meta:{title:t('Deposit')}},
    {path:'/Home',name:'home',component:Home,meta:{title:t('Home')}},
    // /Choose uses the original choose component (with its real Xuanfei/address data flow),
    // restyled with the new KissMora look.
    {path:'/Choose',name:'choose',component:Choose,meta:{title:t('Choose')}},
    {path:'/List',name:'list',component:List,meta:{title:t('List')}},
    {path:'/Profile',name:'profile',component:Profile,meta:{title:t('Profile')}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:t('My Account')}},
    {path:'/Video',name:'video',component:Video,meta:{title:t('Videos')}},
    {path:'/Game',name:'game',component:Game,meta:{title:t('Games')}},
    {path:'/Login',name:'login',component:AuthLogin,meta:{title:t('Login')}},
    {path:'/Register',name:'register',component:AuthRegister,meta:{title:t('Register')}},
    {path:'/VerifyEmail',name:'VerifyEmail',component:VerifyEmail,meta:{title:t('Verify Email')}},
    {path:'/Login-legacy',name:'login-legacy',component:Login,meta:{title:t('Login')}},
    {path:'/Register-legacy',name:'register-legacy',component:Register,meta:{title:t('Register')}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:t('Customer Service')}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:t('Customer Service')}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:t('Settings')}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:t('Basic Information')}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:t('Change Name')}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:t('Change Gender')}},
    {path:'/Language',name:'Language',component:Language,meta:{title:t('Language')}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:t('Recharge')}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:t('Payment Password')}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:t('Login Password')}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:t('Lottery')}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:t('Notices')}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:t('Play Video')}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:t('Crypto Wallet')}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:t('Add Wallet Address')}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:t('Withdraw')}},
    {path:'/Kyc',name:'Kyc',component:Kyc,meta:{title:t('Verify Identity')}},
    {path:'/Gifts',name:'Gifts',component:Gifts,meta:{title:t('My Gifts')}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:t('Personal Report')}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:t('Withdrawal Record')}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:t('Task Log')}},
    {path:'/detail',name:'Details',component:Details,meta:{title:t('Details')}}

];

const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {
    // Hash-mode SPA: /Register without # lands on the wrong view — fix the URL once.
    if (typeof window !== 'undefined') {
        const p = window.location.pathname || '';
        const h = window.location.hash || '';
        if ((p === '/Register' || p === '/Login') && (!h || h === '#/' || h === '#')) {
            window.location.replace('/#' + p + (window.location.search || ''));
            return;
        }
    }
    const meta = to.matched[0] && to.matched[0].meta;
    document.title = (meta && meta.title) || SITE_TITLE;
    // Force password change: block all routes until the member updates their password
    const mustChange = localStorage.getItem('must_change_password') === '1';
    const token = localStorage.getItem('token');
    const allowWhenForced = ['SetLoginPassword', 'login', 'Login', 'register', 'Register', 'VerifyEmail', 'landing'];
    if (mustChange && token && allowWhenForced.indexOf(to.name) === -1) {
        next({ name: 'SetLoginPassword', query: { force: '1' } });
        return;
    }
    // Kick off the top progress bar + route overlay on navigation start
    if (typeof window !== 'undefined' && window.$km) {
        if (window.$km.loader) try { window.$km.loader.start(); } catch(e){ /* ignore */ }
        if (window.$km.routeLoader) try { window.$km.routeLoader.show(to); } catch(e){ /* ignore */ }
    }
    next()
})
router.afterEach(() => {
    if (typeof window !== 'undefined' && window.$km) {
        if (window.$km.loader) try { window.$km.loader.done(); } catch(e){ /* ignore */ }
        if (window.$km.routeLoader) try { window.$km.routeLoader.hide(); } catch(e){ /* ignore */ }
    }
})

export default router